export const CommonConstants = {
    hospitalHelplineCall: "+13131112222",
    emergencyContact1: "+30545868899",
    emergencyContact1_Text: "(305) 4586 8899",
    emergencyContact2: "+30545667788",
    emergencyContact2_Text: "(305) 4566 7788",
};
